import {ActStatusesAPI} from "../../api/api.js";

const SET_ACT_STATUSES = 'actStatisticReducer/SET_ACT_STATUSES'
const SET_PROJECTS_STATUSES = 'actStatisticReducer/SET_PROJECTS_STATUSES'
const SET_PROJECTS = 'actStatisticReducer/SET_PROJECTS'

const initialState = {
    actStatuses: {},
    projectStatuses: {},
    projects: []
}

export const actStatisticReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACT_STATUSES:
            return {
                ...state,
                actStatuses: {...state.actStatuses, [action.name]: action.count}
            }

        case SET_PROJECTS_STATUSES:
            return {
                ...state,
                projectStatuses: action.projectStatuses
            }

        case SET_PROJECTS:
            return {
                ...state,
                projects: action.projects
            }

        default:
            return state
    }
}

export const setActsStatuses = (name, count) => ({type: SET_ACT_STATUSES, name, count})
export const selectActsStatuses = (state) => state.actStatisticReducer.actStatuses

export const setProjects = (projects) => ({type: SET_PROJECTS, projects})
export const selectProjects = (state) => state.actStatisticReducer.projects

export const setProjectsStatuses = (projectStatuses) => ({type: SET_PROJECTS_STATUSES, projectStatuses})
export const selectProjectsStatuses = (state) => state.actStatisticReducer.projectStatuses

export const getActsByStatus = (status) => async (dispatch) => {
    const response = await ActStatusesAPI.getActsStatisticByStatus(status)

    dispatch(setActsStatuses(status, response.data))
}

export const getProjects = () => async (dispatch) => {
    const response = await ActStatusesAPI.getProjects()

    dispatch(setProjects(response.data))
}



// export const getProjectsStatistic = (projects) => async (dispatch) => {
//     let result = {}
//     for (const project of projects) {
//         const response = await ActStatusesAPI.getProjectStatistic(project.id)
//         result[project.id] = response.data
//     }

//     dispatch(setProjectsStatuses(result))
// }